var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header .side_menu');
    var $link = $('.header [data-submenu]');
    var $back = $('.header .level2 .back');
    var $level1 = $('.header .level1');
    var $level2 = $('.header .level2');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
        
        $level1.removeClass('is_hidden');
        $level2.removeClass('is_showed');
        //$('body').toggleClass('locked');
    });

    $link.on('click', function(e) {
        e.preventDefault();

        $id = $(this).data('submenu');
        
        $level1.addClass('is_hidden');
        $level2.removeClass('is_showed');
        $drawerWraper.find('#submenu_'+$id).addClass('is_showed');
    });

    $back.on('click', function(e) {
        e.preventDefault();

        $id = $(this).data('id');
        
        if ($id>0) {
            $level1.addClass('is_hidden');
            $level2.removeClass('is_showed');
            $drawerWraper.find('#submenu_'+$id).addClass('is_showed');
        } else {
            $level1.removeClass('is_hidden');
            $level2.removeClass('is_showed');
        }
    });
}


$(document).ready(function(){
    mp.MenuToggle();
});